import Vue from 'vue';
import App from './App.vue';
import router from './routes/';
import { store } from './store/';
import vSelect from 'vue-select';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { BootstrapVue } from 'bootstrap-vue'
import VueTheMask from 'vue-the-mask'
import PrettyCheckbox from 'pretty-checkbox-vue'
import Lang from 'vue-lang'
import money from 'v-money'
import moment from 'moment'
import VueProgressBar from 'vue-progressbar'
import VueExcelXlsx from './components/VueExcelXlsx'
import titleMixin from './mixins/titleMixin'
 
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'pretty-checkbox/dist/pretty-checkbox.min.css'
import 'pretty-checkbox-vue/dist/pretty-checkbox-vue.min.js'
import 'vue-select/dist/vue-select.css';
import 'vue-date-pick/dist/vueDatePick.css'

let locales = {
  "en": require("./lang/en.js"),
  "es": require("./lang/es.js")
}

const options = {
	color: '#3498db',
	failedColor: '#874b4b',
	thickness: '5px',
	transition: {
		speed: '2s',
		opacity: '0.6s',
		termination: 300
	},
	autoRevert: true,
	location: 'top',
	inverse: false
}

Vue.use(money, {precision: 4})
Vue.use(Lang, {lang: 'es', locales: locales})
Vue.use(PrettyCheckbox)
Vue.use(VueTheMask)
Vue.use(BootstrapVue)
Vue.use(VueProgressBar, options)

library.add(fas)

Vue.component('v-select', vSelect)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-excel-xlsx', VueExcelXlsx)
Vue.mixin(titleMixin)

Vue.prototype.moment = moment

const fb = require('./firebaseConfig.js');

Vue.config.productionTip = false;

// onAuthStateChanged can receive user model if needed
// Handle page reloads
let app
fb.auth.onAuthStateChanged(() => {
	if(!app) {
		app = new Vue({
			el: '#app',
			router,
			store,
			render: h => h(App)
		})
	}
})